import script from "./PrivateCoachingDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivateCoachingDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"

import "./PrivateCoachingDigitalSignatureForm.vue?vue&type=style&index=0&id=66f2deb1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66f2deb1"]])

export default __exports__